const getRoute = (state) => state.getIn(['routing', 'location', 'pathname'])
const getParams = (state) => {
    let pathname = state.getIn(['routing', 'location', 'pathname']);
    let paths;
    try{
        paths = pathname.split('/').filter(route => route.length > 0)
    } catch(error){
        paths =  ['']
    }
    return paths;
}
const getMenuToogle = (state) => state.getIn(['system', 'menu', 'toogle'])
export default {
    getRoute, getParams, getMenuToogle
}



// WEBPACK FOOTER //
// ./src/model/System/selector.js